<template>
    <div class="col-12 summary-item">
        <div class="row align-items-center">
            <SummaryField
                :label="label"
                :value="value"
                :has-error="hasError"
                @edit="edit"
            />
        </div>
    </div>
</template>

<script>
export default {
    emits: ["edit"],
    props: {
        label: null,
        value: null,
        hasError: null
    },
    methods: {
        edit() {
            this.$emit("edit")
        },
    },
}
</script>

<style lang="scss" scoped>
@import '~scss/settings/responsive';
@import '~scss/settings/variables';
@import '~scss/mixins/rem';

.summary-item {
    font-size: rem(16px);
    text-align: left;
    background: #f4f5f6;
    border-radius: 5px;
    margin-bottom: 4px;
    padding-bottom: 15px;
    padding-top: 15px;
}

</style>
